import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, useTheme } from '@mui/system';
import { Box } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import { SubText } from '../../atoms/typography';
const StyledModuleContainer = styled(Box) `
  margin-bottom: 16px;
`;
const StyledModuleTitle = styled(Box) `
  display: flex;
  align-items: center;
  padding-left: 26px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
const StyledListItemButton = styled(ListItemButton, {
    shouldForwardProp: prop => prop !== 'shouldWrapLabel',
}) `
  padding-left: 27px;
  align-items: flex-start;
  & .MuiListItemText-root {
    margin: 0;
    & > span {
      text-overflow: clip;
      white-space: ${({ shouldWrapLabel }) => (shouldWrapLabel ? 'pre-wrap' : 'nowrap')};
    }
  }
`;
const NavigationModule = ({ label, icon, isActive = false, subModules, currentSubModule = '', }) => {
    const theme = useTheme();
    const renderLinks = () => (_jsx(List, { children: subModules?.map(({ name, onClick }) => (_jsx(ListItem, { disablePadding: true, children: _jsxs(StyledListItemButton, { onClick: onClick, children: [_jsx("div", { style: { width: '56px', flexShrink: 0 } }), _jsx(ListItemText, { primary: name, sx: {
                            color: name === currentSubModule ? theme.palette.primary.main : undefined,
                            textAlign: 'left',
                        } })] }) }, name))) }));
    return (_jsxs(StyledModuleContainer, { children: [_jsxs(StyledModuleTitle, { children: [_jsx(ListItemIcon, { sx: { color: isActive ? theme.palette.primary.main : undefined }, children: icon }), _jsx(SubText, { color: theme.palette.text.secondary, children: label })] }), renderLinks()] }));
};
export default NavigationModule;
//# sourceMappingURL=NavigationModule.js.map